import { Sidebar } from '../Sidebar';
import './sidebar-and-container.styles.scss';

interface SidebarAndContainerProps {
  children: React.ReactNode;
  home?: boolean;
  cursos?: boolean;
  webinars?: boolean;
  conectas?: boolean;
  gestaoSalaAula?: boolean;
  materiais?: boolean;
  mentorias?: boolean;
  instrutor?: boolean;
  profile?: boolean;
  ferramentas?: boolean;
  materiaisApoio?: boolean;
  minhasAulasHappy?: boolean;
}

export default function SidebarAndContainer({
  children,
  instrutor,
  materiais,
  cursos,
  webinars,
  conectas,
  gestaoSalaAula,
  profile,
  ferramentas,
  materiaisApoio,
  minhasAulasHappy
}: SidebarAndContainerProps) {
  const sidebarActived = {
    instrutor,
    materiais,
    cursos,
    webinars,
    conectas,
    gestaoSalaAula,
    profile,
    ferramentas,
    materiaisApoio,
    minhasAulasHappy
  };

  return (
    <div className="sidebar-and-container">
      <Sidebar {...sidebarActived} />
      <div className="sidebar-and-container__container">{children}</div>
    </div>
  );
}
